// @ts-nocheck
import React, { useContext, useEffect, useState } from "react";

import OverlayContext from './context/OverlayContext';
import Laundry from './cards/Laundry';
import Pcs from './cards/Pcs';
import Buses from './cards/Buses';
import Outlet from "./cards/Outlets";

interface ICard {
    type: "laundry" | "buses" | "pcs";
    selector: string;
}

const Card: React.FC<ICard> = ({
    type,
    selector,
}) => {
    const { id, buses, pcs, laundry, outlets } = useContext(OverlayContext);

    const getData = () => {
        if (type === "pcs") {
            let filter = pcs.room.filter(item => item.rid === selector);
            let room = (filter.length > 0) ? filter[0] : null;
            return room;
        }

        if (type === "laundry") {
            let filter = laundry.filter(item => item.laundryroom.site === selector);
            return (filter.length > 0) ? filter[0].laundryroom : null;
        }

        if (type === "buses") {
            let filter = buses.filter(item => item.atcoCode === selector);
            return (filter.length > 0) ? filter[0] : null;
        }

        if (type === "outlets") {
            let filter = outlets.filter(item => item.businessID === selector);
            return (filter.length > 0) ? filter[0] : null;
        }

        return null;
    }

    return (
        <div style={{
            position: "absolute",
            bottom: 10,
            left: "50%",
            transform: "translate(-50%, 0)",
            width: "calc(100% - 20px)",
            zIndex: 60,
            backgroundColor: "white",
            maxHeight: "60%",
            overflowY: "auto",
            display: "flex",
            justifyContent: "center",
            boxShadow: "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
            borderRadius: 5,
            fontFamily: "sans-serif",
            maxWidth: "800px",
        }}>

            {(type === "buses" && getData()) && <Buses data={getData()} />}
            {(type === "laundry" && getData()) && <Laundry data={getData()} />}
            {(type === "pcs" && getData()) && <Pcs data={getData()} />}
            {(type === "outlets" && getData()) && <Outlet data={getData()} />}

        </div>
    );
};

export default Card;
